export default __webpack_public_path__ + "static/media/button-more-closed.410fd9dd.svg";